import { Link } from "react-router-dom";
import { sections } from "../data/sections.js";
import MultilineText from "../components/MultilineText";
import { stripGreekTonos } from "../utils/typography";

export default function Home() {
  return (
    <section className="home-page">
      <div className="hero">
        <div className="hero-content">
          {/* <span className="hero-kicker">BUILD YOUR BRAND</span> */}
          <h1>OFFICIAL STORE SUPPLIES</h1>
          <p>
            Επιλέξτε την κατηγορία που σας ενδιαφέρει.
          </p>
        </div>
      </div>

      <div className="section-picker">
        {sections.map((section) => {
          const isExternal = section.path.startsWith("http");

          const cardContent = (
            <>
              <div>
                <div className="section-logo-wrap">
                  <img src={section.logo} alt={section.logoAlt || section.title} />
                </div>
              </div>

              <div>
                <span className="section-card-eyebrow">
                  <MultilineText text={stripGreekTonos(section.eyebrowUpper)} />
                </span>
                <h2>
                  <span className="section-card-title-text">
                    <MultilineText text={section.title} />
                  </span>
                </h2>
                <p>
                  <MultilineText text={section.description} />
                </p>
              </div>

              <strong>Προβολή</strong>
            </>
          );

          if (isExternal) {
            return (
              <a
                key={section.id}
                href={section.path}
                target="_blank"
                rel="noreferrer"
                className={`section-card section-card-${section.theme}`}
              >
                {cardContent}
              </a>
            );
          }

          return (
            <Link
              key={section.id}
              to={section.path}
              className={`section-card section-card-${section.theme}`}
            >
              {cardContent}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
